/* Component Dependencies */
var AriesComponent = require('libs/aries-component');
var makeSendtoLink = require('utils/makeSendtoLink');

var sendToLink = AriesComponent.extend({
  /**
   * This function builds the full url and opens it in a new window.
   * @param {Object} event Event object of target element
   * @returns {Object} Current component instance
   */
  sendToLink: function _sendToLink(event) {
    makeSendtoLink.sendToLink(event);
    return this;
  }
});

module.exports = sendToLink;
